module.exports = __webpack_public_path__ + "img/20250606_0.f9070f35.jpg";